<template>
	<div class="ordering" v-loading.fullscreen.lock="loading">
		<div class="heading">菜品类目</div>
		<div class="content-view">
			<div class="button-view">
				<el-button type="success" size="medium" @click="handleAdd">添加类目</el-button>
				<el-dialog title="添加类目" :visible.sync="dialogVisible" width="40%">
				<el-form v-if="dialogVisible" :model="form" :rules="rules" ref="categoryForm" label-width="100px">
						<el-form-item label="类目名称" prop="category">
							<el-input v-model="form.category" placeholder="请输入类目名称"></el-input>
						</el-form-item>
						<el-form-item label="排序值" prop="catSort">
							<el-input v-model.number="form.catSort" placeholder="请输入排序值"></el-input>
						</el-form-item>
					</el-form>
					<span slot="footer" class="dialog-footer">
						<el-button @click="dialogVisible = false">取 消</el-button>
						<el-button type="primary" @click="submitForm">确 定</el-button>
					</span>
				</el-dialog>
				<el-dialog title="编辑类目" :visible.sync="editDialogVisible" width="40%">
					<el-form v-if="editDialogVisible" :model="editForm" :rules="rules" ref="editForm" label-width="100px">
						<el-form-item label="类目名称" prop="category">
							<el-input v-model="editForm.category" placeholder="请输入类目名称"></el-input>
						</el-form-item>
						<el-form-item label="排序值" prop="catSort">
							<el-input v-model.number="editForm.catSort" placeholder="请输入排序值"></el-input>
						</el-form-item>
					</el-form>
					<span slot="footer" class="dialog-footer">
						<el-button @click="editDialogVisible = false">取 消</el-button>
						<el-button type="primary" @click="updateCategory">确 定</el-button>
					</span>
				</el-dialog>
			</div>
			<div v-if="nodatas">
				<!-- 表头 -->
				<div class="tab-list">
					<span v-for="(item,index) in tablist" :key="index">{{item}}</span>
				</div>
				<!-- 表格 -->
				<div class="tab-table" v-for="(item,index) in tabcont" :key="index">
					<div>{{item.cid}}</div>
					<div>{{item.label}}</div>
					<div>{{item.catSort}}</div>
					<div>
						<el-button size="mini" @click="handleEdit(item)">编辑</el-button>
					</div>
				</div>
				<!-- 分页 -->
				<el-pagination
				  background
				  layout="prev, pager, next"
				  :hide-on-single-page="true"
				  :total="total"
				  :current-page="currentnum"
				  @current-change="currentchange"
				  >
				</el-pagination>
			</div>
			<!-- 没有数据 -->
			<div class="nodatas" v-if="!nodatas">还没有菜品类目</div>
		</div>
		<div style="height: 120px;"></div>
	</div>
</template>

<script>
export default{
	data() {
		return {
			loading: true,
			nodatas:true,
			tablist: ['类目id','类目','排序','操作'],
			tabcont:[],
			currentnum:1,//当前页数
			total:0,//总条数
			pagenum:0,
			dialogVisible: false,
			editDialogVisible: false,
			form: {
				category: '',
				catSort: null
			},
			editForm: {
				id: '',
				category: '',
				catSort: null
			},
			rules: {
				category: [
					{ required: true, message: '请输入类目名称', trigger: 'blur' }
				],
				catSort: [
					{ type: 'number', message: '排序值必须为数字' }
				]
			}
		}
	},
	methods: {
		// 分页
		currentchange(e){
			this.pagenum = e - 1
			this.obtaincate()
		},
		// 添加类目弹窗
		handleAdd() {
			this.dialogVisible = true;
		},
		// 编辑类目
		handleEdit(item) {
			this.editForm = {
				id: item._id,
				category: item.label,
				catSort: item.catSort
			};
			this.editDialogVisible = true;
		},
		// 更新类目
		async updateCategory() {
			try {
				console.log('更新类目请求参数:', {
					id: this.editForm.id,
					category: this.editForm.category,
					catSort: this.editForm.catSort
				});

				//let res = await new this.Request(this.Urls.m().addcategory,this.$qs.stringify(obj)).modepost()
				
				const res = await new this.Request(
					this.Urls.m().updatecategory,
					this.$qs.stringify({
						id: this.editForm.id,
						category: this.editForm.category,
						catSort: this.editForm.catSort
					})
				).modepost();
				
				console.log('更新类目响应:', res);
				
				if (!res) {
					throw new Error('请求无响应');
				}
				
				if (res.status === 200) {
					this.$message.success(res.data && res.data.msg ? res.data.msg : '更新成功');
					this.editDialogVisible = false;
					this.obtaincate();
				} else {
					throw new Error(res.data && res.data.msg ? res.data.msg : '更新失败');
				}
			} catch (e) {
				this.$message.error(e.message || '服务器错误，请重试');
			}
		},
		// 提交表单
		async submitForm() {
			// 基础验证作为备选方案
			if (!this.form.category) {
				this.$message.error('请输入类目名称');
				return;
			}
			if (isNaN(this.form.catSort)) {
				this.$message.error('排序值必须为数字');
				return;
			}
			
			try {
				await this.addcate(this.form.category, this.form.catSort);
				this.dialogVisible = false;
				this.form = {
					category: '',
					catSort: null
				};
			} catch (error) {
				console.error('提交失败:', error);
				this.$message.error('提交失败: ' + error.message);
			}
		},
		
		// 添加类目请求接口
		async addcate(category, catSort){
			let obj = {category, catSort}
			try{
				let res = await new this.Request(this.Urls.m().addcategory,this.$qs.stringify(obj)).modepost()
				if(res.status != 200){
					new this.mytitle(this.$message,'warning',res.data.msg).funtitle()
				}else{
					new this.mytitle(this.$message,'success',res.data.msg).funtitle()
					this.currentnum = 1
					this.pagenum = 0
					this.obtaincate()
				}
			}catch(e){
				new this.mytitle(this.$message,'error','服务器发生错误,请重试').funtitle()
			}
		},
		// 获取菜品类目
		async obtaincate(){
			try{
				let res = await new this.Request(this.Urls.m().obtaincate + '?page=' + this.pagenum).modeget()
				this.nodatas = res.data.data.tatal == 0  ? false : true
				this.tabcont = res.data.data.result
				this.total = res.data.data.tatal
				this.loading = false
			}catch(e){
				new this.mytitle(this.$message,'error','服务器发生错误,请重试').funtitle()
			}
		}
	},
	created() {
		this.obtaincate()
	}
}
</script>

<style scoped="scoped">
@import url("../../../style/pubiss.css");
::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
	background-color: #00be06;
	color: #fff;
}
/* 分页 */
.el-pagination {
	text-align: center;
	margin: 30px 0;
}
@media (max-width: 768px) {
.ordering {
  	width: 135%;
}
.tab-list {
	width: 560px;
}
.tab-table {
	width: 560px;
}
.button-view{
	margin-left: 30px;
}
}
</style>
